import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";
export const ChatUserSkeleton = () => {
  return (
    <div>
      {/* Skeleton for chat */}
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <div
          className="skeleton"
          style={{ width: "48px", height: "48px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "48px" }}
        ></div>
      </div>
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <div
          className="skeleton"
          style={{ width: "48px", height: "48px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "48px" }}
        ></div>
      </div>
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <div
          className="skeleton"
          style={{ width: "48px", height: "48px", borderRadius: "50%" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "230px", height: "48px" }}
        ></div>
      </div>
    </div>
  );
};
